var render, staticRenderFns
import script from "./LoadTrainConfigsMixin.vue?vue&type=script&lang=js"
export * from "./LoadTrainConfigsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256117c",
  null
  
)

export default component.exports